import { Content } from '../../types';

export const phnomPenhContent: Content = {
  title: 'פנום פן (Phnom Penh) – בירת קמבודיה',
  imageUrl: 'https://tinyurl.com/phnom-penh-wide',
  introduction: `פנום פן הינה עיר הבירה של קמבודיה והעיר הגדולה במדינה. היא ממוקמת בנקודת מפגש של שלושה נהרות מרכזיים – המקונג (Mekong), טונלה סאפ (Tonle Sap) ובאסאכ (Bassac) ומשמשת כמרכז השלטוני, הכלכלי, המסחרי והתרבותי של קמבודיה. בעיר מתגוררים כ-2.5 מיליון תושבים והיא משלבת היסטוריה עשירה עם קצב מודרני המתפתח במהירות.`,
  sections: [
    {
      title: 'היסטוריה והתפתחות העיר',
      content: `פנום פן נוסדה במאה ה-14 ולמרות היותה בעבר "פנינת אסיה" תחת השלטון הצרפתי, היא עברה תהפוכות רבות במהלך ההיסטוריה. במלחמת וייטנאם הפכה לעיר מקלט לפליטים שנמלטו מההפצצות האמריקאיות בצפון-מזרח המדינה. בשנת 1975 נכבשה העיר על ידי שלטון הקמר רוז', שהוציא להורג רבים מאנשי האקדמיה, גירש נציגים זרים ופינה בכוח את תושביה לכפרים סמוכים. רק בשנת 1979, עם כיבוש העיר על ידי צבא וייטנאם, החלה פנום פן להשתקם מחדש.

כיום, העיר מציגה שילוב ייחודי של ישן וחדש – מבנים קולוניאליים צרפתיים לצד גורדי שחקים מודרניים, שווקים מסורתיים לצד קניונים מפוארים ועוני לצד התפתחות כלכלית מואצת.`,
      type: 'text',
    },
    {
      title: 'אתרים מרכזיים לביקור',
      content: [
        {
          subtitle: 'מתחם הארמון המלכותי',
          text: 'אחד האתרים המפורסמים בעיר, הכולל את הארמון המשמש כמשכן המלך ואת פגודת הכסף, שבה ניתן למצוא רצפת כסף טהור ופסל בודהה מצופה יהלומים.',
        },
        {
          subtitle: 'המוזיאון הלאומי של קמבודיה',
          text: 'מוזיאון חשוב המציג אוסף מרשים של אמנות חמרית עתיקה.',
        },
        {
          subtitle: 'ואט פנום (Wat Phnom)',
          text: 'מקדש בודהיסטי עתיק הממוקם בראש גבעה, המשקיפה על העיר ומהווה אתר פולחן חשוב.',
        },
        {
          subtitle: 'אנדרטת העצמאות',
          text: 'הוקמה לכבוד עצמאותה של קמבודיה מצרפת בשנת 1953.',
        },
        {
          subtitle: 'מוזיאון טול סלנג (Tuol Sleng Genocide Museum - S-21)',
          text: "בעבר היה זה בית ספר שהפך בתקופת הקמר רוז' לכלא ועינוי פוליטי וכיום הינו מוזיאון לזכר קורבנות המשטר האכזרי.",
        },
        {
          subtitle: 'שדות הקטל (Killing Fields of Choeung Ek)',
          text: 'אתר זיכרון מצמרר המספר את סיפור רצח העם הקמבודי.',
        },
      ],
      type: 'list',
    },
    {
      title: 'שווקים, קניות ובילויים',
      content: [
        {
          subtitle: 'השוק הרוסי (Psar Toul Tom Poung)',
          text: 'שוק מסורתי ובו מבחר בגדים, תכשיטים, מזכרות ומוצרי עבודת יד מקומיים.',
        },
        {
          subtitle: 'השוק המרכזי (Central Market)',
          text: 'מבנה קולוניאלי צרפתי עם מבחר של תכשיטים, ביגוד ודוכני אוכל מקומי.',
        },
        {
          subtitle: 'שוק הלילה',
          text: 'ממוקם סמוך לנהר טונלה סאפ ומציע דוכני אוכל מקומיים ומוזיקה חיה.',
        },
        {
          subtitle: 'קניוני Aeon',
          text: 'מרכזי קניות מודרניים עם מותגים בינלאומיים, קולנוע ומתחמי אוכל מגוונים.',
        },
      ],
      type: 'list',
    },
    {
      title: 'חוויות מיוחדות',
      content: `שייט בשקיעה במפגש שלושת הנהרות – חוויה מומלצת במיוחד! ניתן לצפות בשמש שוקעת על רקע קו הרקיע של העיר, תוך כדי שייט רגוע בנהרות.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `פנום פן הינה עיר בעלת עבר מרתק והווה מתפתח במהירות. השילוב בין היסטוריה, תרבות וקצב עירוני מודרני הופך אותה ליעד מרתק לכל מטייל.`,
      type: 'text',
    },
  ],
};
